import React, { Component, Fragment, PureComponent } from 'react';
import { inject, observer } from 'mobx-react';
// import moment from 'moment';

@inject('lineStore', 'dictStore')
@observer
class Sport extends Component{

    handleSelect = (type, id) => {
        this.props.lineStore.schedule.selectSport(type, id);
    }

    render() {
        const { getLang } = this.props.dictStore;
        const { select, dict, menu } = this.props.lineStore.schedule;
        const { id } = this.props;

        if (!menu.current) return null;

        let name = '';
        if (id === 'other') {
            name = getLang('OTHER');
        } else {
            name = dict.sport[id];
        }
        const selectId = select.sport.find( item => item == id );

        if (menu.current.indexOf(id) != -1 || id == 'other') {
            return(      
                <li>
                    <button className={`checkbox ${selectId ? 'on' : ''}`} onClick={() => this.handleSelect(2, id)}>
                        <span></span>
                        { name }
                    </button>
                </li>        
            )
        } 

        return null;
    }
}

@inject('lineStore', 'dictStore')
@observer
class SelectSport extends Component{

    handleSelect = (id, type) => {
        this.props.lineStore.schedule.selectSport(type, id);
    }

    render() {

        const { getLang } = this.props.dictStore;
        const { allSport } = this.props.lineStore.schedule.select;
        const { order } = this.props;

        return(
            <div className="results-sport clearfix">
                <ul className="sport-list clearfix">
                    <li>
                        <button className={`results-index-sport_item checkbox ${allSport ? 'on' : ''}`} onClick={() => this.handleSelect('all', 1)}>
                            <span></span>
                            { getLang('ALL_EVENTS') }
                        </button>
                    </li>   
                    {
                        order.map(id => 
                            <Sport id={id} key={id}/>
                        )
                    } 
                </ul>
            </div>
        )
    }
}


@inject('lineStore', 'dictStore')
@observer
export default class Filter extends Component{

    handleSelectTime = (time) => {
        this.props.lineStore.schedule.setTime(time);
    }

    handleSelectSort = (sort) => {
        this.props.lineStore.schedule.setSort(sort);
    }

    render() {

        const { timeline, select, menu } = this.props.lineStore.schedule;
        const { getLang } = this.props.dictStore;

        if (!menu.comparison && !menu.order && !menu.current && !timeline.length) return null;

        return(
            <div className="schedule-menu">
                <div className="results-index-info clearfix">
                    <div className="results-date-info fl_l">
                        <div className="results-index-menu-item ">
                            {
                                timeline.map(el => 
                                    <button key={el.id} className={`results-index-type ${select.time == el.id ? 'on' : ''}`} onClick={() => this.handleSelectTime(el.id)} >
                                        { getLang(el.name) }
                                    </button>
                                )   
                             }
                        </div>
                        <div className="results-index-menu-item">
                        </div>
                    </div>
                    <div className="results-date-info fl_r">
                        <div className="results-index-menu-item ">
                            <button className={`results-index-type ${select.sort == 'time' ? 'on' : ''}`} onClick={() => this.handleSelectSort('time')} >
                                { getLang('BY_TIME') }
                            </button>
                            <button className={`results-index-type ${select.sort == 'abc' ? 'on' : ''}`} onClick={() => this.handleSelectSort('abc')} >
                                { getLang('ALPHABETICALLY') }
                            </button>
                        </div>
                        <div className="results-index-menu-item">
                        </div>
                    </div>
                </div>
                <SelectSport order={menu.order} />
            </div>
        )
    }
} 


// WEBPACK FOOTER //
// ./src/components/schedule/filter.jsx